import { render } from "./QuantityOfTransfersPerMonthChart.vue?vue&type=template&id=22c0a306"
import script from "./QuantityOfTransfersPerMonthChart.vue?vue&type=script&lang=js"
export * from "./QuantityOfTransfersPerMonthChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__